var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'pdf-page-container': true, repeat: _vm.repeat },style:({ backgroundImage: 'url(' + _vm.bgUrl + ')' })},[_vm._t("extra"),_c('img',{staticClass:"pdf-page-footer",attrs:{"src":require("@/assets/report/report/pdf_logo.png"),"alt":""}}),_c('div',{staticClass:"pdf-page-main"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }